import {useState} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {FEATUREBASE_JWT} from "@/lib/featureFlags.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {AccountUser} from "@/lib/types/accounts.ts";

const FEATUREBASE_JWT_ENDPOINT = `${URL_ORIGINAL_WEBSITE}/featurebase/jwt`;

export const useFeatureBase = () => {
  // @ts-expect-error: attached to window in index.html
  const featurebase = window.Featurebase;
  const {userHasFeature} = useCurrentUserContext();
  const [identifiedUserId, setIdentifiedUserId] = useState<number>();

  return {
    init: (user: AccountUser) => {
      if (!featurebase || identifiedUserId === user.id) {
        return;
      }
      setIdentifiedUserId(user.id);

      if (!userHasFeature(FEATUREBASE_JWT)) {
        featurebase("identify", {
          organization: "uptime",
          email: user.email,
          name: `${user.first_name} ${user.last_name}`,
          id: `${user.id}`,
          customFields: {
            "Account ID": `${user.account.id}`,
            "Account Name": `${user.account.name}`,
          },
        });
        return;
      }

      void (async () => {
        try {
          const response = await fetch(FEATUREBASE_JWT_ENDPOINT, {credentials: "include"});
          if (!response.ok) {
            return;
          }
          const data: {jwt: string} = await response.json();
          featurebase("identify", {
            organization: "uptime",
            featurebaseJwt: data.jwt,
          });
        } catch (error) {
          console.warn("Featurebase identify failed:", error);
        }
      })();
    },
  };
};
